import * as React from "react"
import { Container } from "react-bootstrap"
import { Helmet } from "react-helmet"
import { useTranslation } from "react-i18next"
import { Navigate, useParams } from "react-router-dom"
import { ApplicationForm } from "../components/jobs/application-form"
import { Conditions } from "../components/jobs/conditions"
import { Flow } from "../components/jobs/flow"
import { JobItemLarge } from "../components/jobs/jobItemLarge"
import { Layout } from "../components/layout"
import { Head } from "../components/seo"
import { jobs } from "../contents/job/jobs"
import { generateJobPostingJsonLd } from "../utils/generateJobPostingJsonLd"

export const JobDetailPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const { t, i18n } = useTranslation("jobs");
  const job = jobs.find(j => j.slug === slug);

  if (!job) {
    return <Navigate to="/404" replace />;
  }

  const title = `RECRUIT / ${t(job.titleEng)}`;
  const subtitle = i18n.language === "ja" ? `求人 / ${t(job.title)}` : "";

  // Google Jobs用のJSON-LD構造化データを生成
  const jobTitle = t(job.title)
  const jobDescription = t(job.description)
  const jsonLd = generateJobPostingJsonLd(job, jobTitle, jobDescription, i18n.language)

  return (
    <Layout title={title} subtitle={subtitle}>
      <Head title={t(job.title)} />
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(jsonLd, null, 2)}
        </script>
      </Helmet>
      <Container className="my-5">
        <JobItemLarge job={job} />
        <div className="my-4">
          <Flow />
          <Conditions />
        </div>
      </Container>
      <ApplicationForm job={job} />
    </Layout>
  )
}